export function Footer() {
  return (
    <footer id="footer" className="section footer-section" aria-label="Footer">
      <div className="section-inner footer-inner">
        <div className="footer-brand">
          <span className="footer-logo">eduksy.</span>
          <p className="footer-tagline">AI is making education worse.<br />We&apos;re building the antidote.</p>
        </div>
        <div className="footer-links">
          <a href="/demo" className="footer-link">Demo Hub</a>
          <a href="/arena" className="footer-link">Arena</a>
          <a href="/sandbox" className="footer-link">Sandbox</a>
          <a href="/pitch-deck" className="footer-link">Pitch Deck</a>
          <a href="/" className="footer-link">Manifesto</a>
        </div>
      </div>
    </footer>
  );
}
